import React, { useState } from 'react';
import { Flex, Text, Heading, Input } from '@chakra-ui/core';
import { useStoreState, useStoreActions } from 'easy-peasy';

import theme, { colors } from '@styles/theme-chakra';
import { AppStoreBadge } from '@zeta';
import RightArrow from '../../assets/RightArrow';
import { formatToPhone } from '../../lib/inputHelpers';

const TextZjc = () => {
  return (
    <div key="send-text">
      <Heading
        py={[4, 4]}
        fontSize={[theme.fontSizes['2xl'], theme.fontSizes['4xl']]}
        as="h1"
        fontWeight="semibold"
      >
        Download Zeta Joint Cards
      </Heading>
      <Heading
        py={[4, 4]}
        fontSize={[theme.fontSizes['md'], theme.fontSizes['md']]}
        as="h3"
        fontWeight="regular"
      >
        Currently only available on the App Store or Google Play.
      </Heading>
      <Flex direction={['column', 'row']} mt={[4, 2]}>
        <Flex mr={5}>
          <AppStoreBadge platform="android" height={60} zjcDirect />
        </Flex>
        <Flex mt={[4, 0]}>
          <AppStoreBadge platform="ios" height={60} zjcDirect />
        </Flex>
      </Flex>
      <TextForm />
    </div>
  );
};

const TextForm = () => {
  const { sendZjcText } = useStoreActions(actions => actions.modalDisplay);
  const [sent, setSent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  const sendText = () => {
    setSent(true);
    sendZjcText({ variables: { phoneNumber } });
    return true;
  };

  return (
    <>
      <Flex mt={8} mb={8} width={'100%'}>
        <Flex direction="row" width={'100%'} alignItems="center">
          {sent ? (
            <Flex direction="column">
              <Text>
                We've sent a text to {formatToPhone(phoneNumber)}. Check your phone for
                next steps.
              </Text>
              <br />
              <a
                href="#"
                onClick={() => {
                  setSent(false);
                }}
                style={{ color: colors.greenPea }}
              >
                Click to resend.
              </a>
            </Flex>
          ) : (
            <Flex direction="column">
              <Text>Want us to text you the link instead?</Text>
              <Flex direction="row" mt={[4]}>
                <Input
                  backgroundColor="#FFFFFF"
                  border={'1px solid #000000'}
                  borderRadius="8px"
                  variant="flushed"
                  paddingLeft="1rem"
                  focusBorderColor={colors.greenPea}
                  w={80}
                  onChange={e => {
                    setPhoneNumber(e.target.value);
                  }}
                  onKeyUp={e => {
                    if (e.key == 'Enter') {
                      sendText();
                    }
                  }}
                  value={formatToPhone(phoneNumber)}
                  placeholder="Share your digits"
                />
                <Flex
                  ml={4}
                  width="2.5rem"
                  height="2.5rem"
                  minWidth="2.5rem"
                  maxHeight="2.5rem"
                  backgroundColor={colors.greenPea}
                  borderRadius="50%"
                  justify="center"
                  align="center"
                  cursor="pointer"
                  onClick={sendText}
                  id="joint-account-waitlist-subscribe"
                >
                  <RightArrow fill={colors.white} height={16} disabled={sent} />
                </Flex>
              </Flex>
            </Flex>
          )}
        </Flex>
      </Flex>
    </>
  );
};

export default TextZjc;
